import {ThemeProvider} from '@primer/react-brand'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import LegacyEnterpriseIndex from './LegacyEnterpriseIndex'

import AISection from './AISection'
import AnchorNav from './AnchorNav'
import CTASection from './CTASection'
import HeroSection from './HeroSection'
import ReliabilitySection from './ReliabilitySection'
import ScaleSection from './ScaleSection'
import SecuritySection from './SecuritySection'

export default function EnterpriseIndex() {
  const isNewVersionEnabled = isFeatureEnabled('site_universe24_enterprise')

  if (isNewVersionEnabled) {
    return (
      <ThemeProvider colorMode="dark" className="enterprise-lp enterprise-dark-bg">
        <HeroSection />

        <AnchorNav />

        <ScaleSection />
        <AISection />
        <SecuritySection />
        <ReliabilitySection />
        <CTASection />
      </ThemeProvider>
    )
  }

  return <LegacyEnterpriseIndex />
}

try{ EnterpriseIndex.displayName ||= 'EnterpriseIndex' } catch {}